import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e78f9e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-settings-menu" }
const _hoisted_2 = ["data-test-id", "onClick"]
const _hoisted_3 = { class: "menu-item__label" }

import { useAuthStore } from '@/store/auth'
import { useRouter } from 'vue-router'
import { ROUTE_PATHS } from '@/router/paths'
import BaseIcon from '@/components/BaseIcon.vue'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'UserSettingsMenu',
  setup(__props) {

const i18n = useI18n()
const menuItems = [
  {
    label: i18n.t('profileSettings'),
    icon: 'profile-settings',
    action: onProfileSettingsClick,
    visible: false,
  },
  {
    label: i18n.t('manageAccount'),
    icon: 'manage-account',
    action: onManageAccountClick,
    visible: false,
  },
  {
    label: i18n.t('logOut'),
    icon: 'logout',
    action: onLogoutClick,
    class: 'logout',
    dataTestId: 'log-out',
    visible: true,
  },
]
const authStore = useAuthStore()
const router = useRouter()

function onProfileSettingsClick() {
  return null
}

function onManageAccountClick() {
  return null
}

function onLogoutClick() {
  authStore.logout()
  localStorage.removeItem('tour-token')
  router.push({ name: ROUTE_PATHS.LOGIN })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuItems, (menuItem) => {
      return _withDirectives(_createElementVNode("div", {
        key: menuItem.label,
        class: _normalizeClass(["menu-item", menuItem.class]),
        "data-test-id": menuItem.dataTestId,
        onClick: menuItem.action
      }, [
        _createVNode(BaseIcon, {
          class: "menu-item__icon",
          icon: menuItem.icon,
          size: 22
        }, null, 8, ["icon"]),
        _createElementVNode("div", _hoisted_3, _toDisplayString(menuItem.label), 1)
      ], 10, _hoisted_2), [
        [_vShow, menuItem.visible]
      ])
    }), 64))
  ]))
}
}

})